import { Box, styled, Table, TableCell, TableRow, Typography } from "@mui/material";
import { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { DetailsTableContent } from "@sinch/components/application/RateComponentsMarginTable/DetailsTableContent";
import { ComponentRow } from "@sinch/components/application/RateComponentsMarginTable/RateComponentsMargin";
import { TableTitle } from "@sinch/components/application/RatesCompositionTable/styledTableComponents";

/**
 * Detail panel content showing price and wage breakdown
 */
export const DetailPanelContent: FC<{ row: ComponentRow }> = memo(({ row }) => {
  const { t } = useTranslation(["common"]);

  return (
    <PaddedBox>
      <CompositionTable>
        <TableTitle>
          <TableRow>
            <TableCell colSpan={4}>
              <Typography variant="caption">{t("price")}</Typography>
            </TableCell>
          </TableRow>
        </TableTitle>
        <DetailsTableContent items={row.priceOverview ?? []} total={row.price} totalTitle={t("total")} />

        <TableTitle>
          <TableRow>
            <TableCell colSpan={4}>
              <Typography variant="caption">{t("wage")}</Typography>
            </TableCell>
          </TableRow>
        </TableTitle>
        <DetailsTableContent items={row.wageOverview ?? []} total={row.wage} totalTitle={t("total")} />
      </CompositionTable>
    </PaddedBox>
  );
});

DetailPanelContent.displayName = "DetailPanelContent";

const PaddedBox = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(2),
  paddingLeft: "50px",
  paddingRight: theme.spacing(1),
}));
const CompositionTable = styled(Table)({
  "& td, & th": {
    paddingTop: "4px",
    paddingBottom: "4px",
  },
});
